import EmptyImagesListIcon from '@/common/assets/icons/emptyImagesList.svg?react';
import TitleDescription from '@/common/components/base/typography/TitleDescription';
import Typography from '@/common/components/base/typography/Typography';
import ImageCard from '@/common/components/imageGallery/components/ImageCard';
import MainLayout from '@/common/components/layouts/MainLayout';
import LoadingPage from '@/common/pages/LoadingPage';
import AlertIcon from '@/modules/adjusterReportModules/IncidentParticipants/assets/icons/alertIcon.svg?react';
import getDamagedCustomerImageTabsAlertsQueryOptions from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerImageTabsAlerts/getDamagedCustomerImageTabsAlertsQueryOptions';
import { getDamagedCustomerVehicleImagesQueryOptions } from '@/modules/adjusterReportModules/IncidentParticipants/queries/getDamagedCustomerVehicleImages/getDamagedCustomerVehicleImagesQueryOptions';
import { useQuery } from '@tanstack/react-query';
import { useParams } from 'react-router-dom';
import { css } from 'styled-system/css';
import { Box, Flex } from 'styled-system/jsx';
import { grid } from 'styled-system/patterns';
export default () => {
  return (
    <MainLayout
      title="زیان‌دیده / تصاویر"
      header="titleHeader"
      hasBottomPadding
    >
      <VehicleImages />
    </MainLayout>
  );
};

const VehicleImages = () => {
  const { id, damagedId } = useParams();

  const { data: alertData } = useQuery(
    getDamagedCustomerImageTabsAlertsQueryOptions({
      damage_id: damagedId!,
      id: id!,
    }),
  );
  const { data: documentImagesList, isRefetching: getListLoading } = useQuery(
    getDamagedCustomerVehicleImagesQueryOptions({
      damaged_id: Number(damagedId),
      id: Number(id),
    }),
  );
  if (getListLoading) return <LoadingPage />;

  return (
    <Box pt="1.5rem">
      <TitleDescription>تصاویر وسیله‌نقلیه</TitleDescription>
      {alertData?.need_to_accept_customer_images ? (
        <Flex
          mt="1.5rem"
          className={css({
            p: '0.5rem 1.5rem',
            borderRadius: '10px',
            backgroundGradient: 'to-r',
            gradientFrom: '#F1F0F8',
            gradientTo: 'transparent',
          })}
          gap="1rem"
          justifyContent="center"
          alignItems="center"
        >
          <Box>
            <AlertIcon />
          </Box>
          <Typography textAlign="center" textStyle="b1" color="purple-primary">
            تصاویر مشتری رد شده است، لازم است نسبت به ارزیابی اقدام نمایید.
          </Typography>
        </Flex>
      ) : null}

      {documentImagesList?.vehicle?.length ? (
        <>
          <Typography mt="1.5rem" textStyle="b1" color="purple-primary">
            تصاویر دور تا دور وسیله‌نقلیه{' '}
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {documentImagesList.vehicle?.map((image) => (
              <ImageCard
                key={image.id}
                imageData={{
                  name: image.title.fa_const,
                  src: image.image,
                }}
                extension={{
                  type: 'download',
                }}
              />
            ))}
          </Flex>
        </>
      ) : null}
      {documentImagesList?.damaged_parts?.length ? (
        <>
          <Typography mt="1.5rem" textStyle="b1" color="purple-primary">
            تصاویر نقاط آسیب‌دیده
          </Typography>
          <Flex
            gap="1rem"
            maxWidth="maxContainer"
            margin="auto"
            mt="1.5rem"
            className={grid({ columns: 2 })}
          >
            {documentImagesList.damaged_parts?.map((damagedImages) => (
              <ImageCard
                key={damagedImages.id}
                imageData={{
                  name: damagedImages.title.fa_const,
                  src: damagedImages.image,
                }}
                extension={{
                  type: 'download',
                }}
              />
            ))}
          </Flex>
        </>
      ) : null}
      {documentImagesList?.damaged_parts?.length &&
      !documentImagesList?.vehicle?.length ? (
        <Box mt="100px">
          <EmptyImagesListIcon className={css({ mx: 'auto' })} />
        </Box>
      ) : null}
    </Box>
  );
};
